export function initTabs() {
  const test = "Tabs boy";
}
